export { default } from './InventoryItemInfo';

